export const getLineWidth = (baseLineWidth, zoom) => zoom > 0
    ? baseLineWidth / (zoom + 1)
    : baseLineWidth * (Math.abs(zoom) + 1);
//# sourceMappingURL=util.js.map